module.exports = `
  type Basic {
    done: Boolean
  }
`;
